import user from "../views/pages/app/user";

export default {
    getHeaderForMvp: () => {
        let userInfo = localStorage.getItem('ced:user-info')
        let token = null
        if (userInfo) {
            const user = JSON.parse(userInfo)
            token = user.accessToken
        }
        return {'authorization': token}
    }
}